import { WorkLog } from '@klubovna/api-client';
import { PaginationMetadata } from '@shared';

export interface WorkLogsState {
  workLogs: WorkLog[];
  loading: boolean;
  error: string | null;
  pagination: PaginationMetadata;
}

export const initialWorkLogsState: WorkLogsState = {
  workLogs: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};

